import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "item-badge" }
const _hoisted_2 = { class: "item-content" }
const _hoisted_3 = {
  class: "btn-group btn-group-vertical radio-group",
  "data-toggle": "buttons"
}
const _hoisted_4 = ["onClick", "id", "name"]
const _hoisted_5 = ["onClick", "for"]

import { useWizardStepsStore } from "../store/wizardStepsStore";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Step',
  setup(__props) {

const store = useWizardStepsStore();
const currentStep = ref<HTMLDivElement>();

const goToStep = (option: Step) => {
  store.previousSteps.push({ ...store.currentStep, chosenValue: option.id });

  const nextStep = store.currentStep.subItems.find((subItem) => {
    return subItem.id === option.id
  }) as Step;

  store.currentStep = nextStep.subItems[0];

  window.scroll({
    top: currentStep.value!.offsetTop - 40,
    behavior: 'smooth'
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "timeline-item active js-timeline-step active",
    ref_key: "currentStep",
    ref: currentStep
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(store).previousSteps.length + 1), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_unref(store).currentStep.caption), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).currentStep.subItems, (subItem) => {
          return (_openBlock(), _createElementBlock("div", {
            key: subItem.id,
            class: "radio-button btn"
          }, [
            _createElementVNode("input", {
              onClick: _withModifiers(($event: any) => (goToStep(subItem)), ["prevent"]),
              id: `radio-${subItem.id}`,
              name: `radio-${_unref(store).currentStep.id}`,
              type: "radio",
              class: "radio-button__input"
            }, null, 8 /* PROPS */, _hoisted_4),
            _createElementVNode("label", {
              onClick: _withModifiers(($event: any) => (goToStep(subItem)), ["prevent"]),
              for: `radio-${subItem.id}`,
              class: "radio-button__label radio-text"
            }, _toDisplayString(subItem.caption), 9 /* TEXT, PROPS */, _hoisted_5)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ], 512 /* NEED_PATCH */))
}
}

})